import React, { useMemo } from 'react';

import { FRequestLogFragment } from '@dashboard/generated/wp/platform';
import { Stack, Typography } from '@mui/material';

import { DateFormatter } from '@waypoint/react-formatters';

type Props = {
  selected: boolean;
  model: FRequestLogFragment;
  onClick: () => void;
};

function StatusCode({ code }: { code: number }) {
  const color = useMemo(() => {
    if (200 <= code && code < 300) {
      return 'brand.green';
    }
    return 'error';
  }, [code]);
  return (
    <Typography variant="body2" color={color}>
      {code}
    </Typography>
  );
}

export default function ListItem({ selected, model, onClick }: Props) {
  const path = useMemo(() => {
    try {
      const u = new URL(model.url);
      return model.url.replace(u.origin, '');
    } catch (e) {
      return model.url;
    }
  }, [model]);
  return (
    <Stack
      spacing={1}
      direction="row"
      alignItems="baseline"
      onClick={onClick}
      justifyContent="space-between"
      sx={{
        gap: 1,
        py: 1.25,
        px: 2,
        bgcolor: selected ? 'cadet.300' : undefined,
        '&:hover': {
          bgcolor: selected ? 'cadet.300' : 'cadet.100',
          cursor: 'pointer',
        },
      }}
    >
      <StatusCode code={model.statusCode} />
      <Typography variant="body2" noWrap textAlign="left" width="100%">
        <strong>{model.method}</strong>&ensp;
        <Typography variant="caption" color="text.secondary">
          {path}
        </Typography>
      </Typography>
      <Typography variant="body2" color="text.secondary" noWrap sx={{ textAlign: 'right', flexShrink: 0 }}>
        <DateFormatter value={model.createdAt} />
      </Typography>
    </Stack>
  );
}
